<template>
  <div>
    <div v-if="impersonation" class="fixed bottom-0 left-0 right-0 z-[99999] flex items-center justify-center gap-4 bg-amber-500 px-4 py-2 text-sm font-medium text-black shadow-lg">
      <span>Acesso de suporte (somente leitura) · {{ impersonation.by }} · você está vendo a conta de {{ user && user.name }}</span>
      <button class="rounded bg-black px-3 py-1 text-white" @click="exitImpersonation">Sair</button>
    </div>
    <div v-if="layout === 'empty-layout'">
      <router-view></router-view>
    </div>
    <div v-else-if="token">
      <TemplateAdmin />
    </div>
    <router-view v-else></router-view>
  </div>
</template>

<script>
import TemplateAdmin from "_app/resources/templates/TemplateAdmin.vue";

const CHATWOOT_URL = 'https://www.chat.wbuy.com.br';
const CHATWOOT_TOKEN = 'XDgc4v26vVKrycHcixvp9u4m';
const CHATWOOT_SCRIPT_ID = 'chatwoot-sdk-script';
const CHATWOOT_HOLIDAYS = ['2026-10-12', '2026-11-02', '2026-11-20', '2026-12-25'];

export default {
  name: "App",
  data() {
    return {
      token: this.$SessionService.getToken(),
      user: this.$SessionService.getUser(),
    };
  },

  components: {
    TemplateAdmin,
  },

  computed: {
    // Sessão aberta pelo painel admin (acesso de suporte)
    impersonation() {
      try {
        return JSON.parse(localStorage.getItem("data") || "null")?.impersonation || null;
      } catch (e) {
        return null;
      }
    },

    layout() {
      return this.$route.meta?.layout;
    },

    isLogin() {
      return this.layout === 'empty-layout';
    }
  },

  watch: {
    $route() {
      this.token = this.$SessionService.getToken();
      this.handleChatwootWidget();
    },

    token: {
      handler(newValue) {
        if (!newValue) {

        }
      },
      immediate: true,
    },
  },

  mounted() {
    this.handleChatwootWidget();
  },

  methods: {
    async exitImpersonation() {
      try {
        await this.$ApiService.post("auth/logout", {});
      } catch (e) {
        console.error(e);
      }
      localStorage.removeItem("data");
      window.location.href = "/auth/login";
    },

    handleChatwootWidget() {
      if (window.chatwootSDK) {
        this.applyChatwootSchedule();
        return;
      }
      if (document.getElementById(CHATWOOT_SCRIPT_ID)) return;

      window.chatwootSettings = {
        position: 'left',
        type: 'standard',
        launcherTitle: '',
        hideMessageBubble: true,
      };
      window.addEventListener('chatwoot:ready', this.applyChatwootSchedule);

      const script = document.createElement('script');
      script.id = CHATWOOT_SCRIPT_ID;
      script.async = true;
      script.src = `${CHATWOOT_URL}/packs/js/sdk.js`;
      script.onload = () => {
        window.chatwootSDK.run({ websiteToken: CHATWOOT_TOKEN, baseUrl: CHATWOOT_URL });
      };
      document.head.appendChild(script);
    },

    // O balão só aparece em horário de atendimento (seg-sex, 09:00-17:45, America/Sao_Paulo, exceto feriados)
    applyChatwootSchedule() {
      if (!window.$chatwoot) return;
      const parts = {};
      new Intl.DateTimeFormat('en-US', {
        timeZone: 'America/Sao_Paulo',
        weekday: 'short',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        hourCycle: 'h23',
      }).formatToParts(new Date()).forEach((v) => { parts[v.type] = v.value; });

      const minutes = +parts.hour * 60 + +parts.minute;
      const open = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri'].includes(parts.weekday)
        && minutes >= 540 && minutes < 1065
        && !CHATWOOT_HOLIDAYS.includes(`${parts.year}-${parts.month}-${parts.day}`);

      window.$chatwoot.toggleBubbleVisibility(open ? 'show' : 'hide');
    },
  },

};
</script>
